define(['text!./templates/binary-choice.html'],
    (templateStr)=> {
        let controlId = 0;

        return [()=> {
            return {
                restrict: 'A',
                template: templateStr,
                scope: {
                    titleLeft: '@',
                    titleRight: '@',
                    valueLeft: '=',
                    valueRight: '=',
                    model: '='
                },
                controller: ['$scope', ($scope)=> {
                    $scope.controlId = `binaryinputctrlx${controlId++}`;
                }]
            };
        }];
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/inputs/BinaryChoice.js